export const warmData = [
    {
        id: 1,
        organisationName: "ООО Газпром теплоэнерго МО*",
        service: 
        [
            {
                serviceType: "теплоснабжение",
                prices22: "4871,05",
                prices23: "4952,24"
            }
        ]
    },

    {
        id: 2,
        organisationName: "ООО Газпром теплоэнерго МО, поставщик воды для приготовления ГВС- МУП Межрайонный Щелковский Водоканал**",
        service:
        [
            {
                serviceType: "компонент на ХВС",
                prices22: "37,58",
                prices23: "38,21",
            },
            {
                serviceType: "компонент на тепловую энергию",
                prices22: "4871,05",
                prices23: "4952,24"
            },
        ]
    }
]